import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { AssessmentOutlined } from '@mui/icons-material';
import { useReportingEditor } from '../../../../hooks/useReportingEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

const reportTypeOptions = [
  { value: 'NEW', label: 'New Report' },
  { value: 'EXISTING', label: 'Existing Report' },
];

export const ReportTypeEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useReportingEditor(mode);
  const labelId = `${mode}-report-type-label`;

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth required>
        <InputLabel id={labelId}>Report Type</InputLabel>
        <Select
          labelId={labelId}
          value={request?.reportType || ''}
          onChange={(e) => updateRequest({ reportType: e.target.value })}
          label="Report Type"
          startAdornment={
            <InputAdornment position="start">
              <AssessmentOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {reportTypeOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ReportTypeEditor;
